import { Text } from '@mantine/core';
import { DataTableColumn } from 'mantine-datatable';
import React from 'react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { SimpleTable } from 'src/common/components/table/SimpleTable';
import { formatDate } from 'src/financial/financial-data/tables/FinancialItemGenericTable';
import { Company } from 'src/secret-menu/hooks/useCompanies';
import { MeetingAgendaDraftsModal } from './MeetingAgendaDraftsModal';
import { AdminMeetingAgenda } from './types';

type MeetingAgendasTableProps = {
  company: Company;
};

export function MeetingAgendasTable({ company }: MeetingAgendasTableProps) {
  const [selectedId, setSelectedId] = React.useState<string | null>(null);

  const columns: DataTableColumn<AdminMeetingAgenda>[] = [
    {
      accessor: 'id',
      title: 'ID',
      render: (record: AdminMeetingAgenda) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {record.id}
        </Text>
      ),
    },
    {
      accessor: 'clientId',
      title: 'Client ID',
      render: (record: AdminMeetingAgenda) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {record.clientId}
        </Text>
      ),
    },
    {
      accessor: 'templateId',
      title: 'Template ID',
      render: (record: AdminMeetingAgenda) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {record.templateId ?? '-'}
        </Text>
      ),
    },
    {
      accessor: 'createdAt',
      title: 'Created at',
      width: 170,
      render: (record: AdminMeetingAgenda) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {record.createdAt ? formatDate(record.createdAt) : '-'}
        </Text>
      ),
    },
    {
      accessor: 'markdownPreview',
      title: 'Preview',
      render: (record: AdminMeetingAgenda) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10" lineClamp={2}>
          {record.markdownPreview ?? '-'}
        </Text>
      ),
    },
  ];

  return (
    <>
      <MeetingAgendaDraftsModal
        meetingAgendaId={selectedId}
        companyId={company.id}
        onClose={() => setSelectedId(null)}
      />

      <SimpleTable<AdminMeetingAgenda>
        mode="server"
        resource={`admin/companies/${company.id}/meeting-agendas`}
        title="Meeting agendas"
        columns={columns}
        onRowClick={record => setSelectedId(record.id)}
        showCount
      />
    </>
  );
}
